import React, { useState, useEffect, useRef } from 'react';
import {
    Container, Row, Col, Card, Button, Form, Table,
    Tabs, Tab, Alert, Modal, Badge,
    InputGroup, Dropdown
} from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import AsyncSelect from "react-select/async";
import DataApi from '../../api/dataApi';
import Loader from '../common/Loader';
import { toast } from "react-toastify";
import PurchaseDataImport from "../common/PurchaseDataImport";
import UniversalBarcodeScanner from './UniversalBarcodeScanner';
import PubSub from 'pubsub-js';
import "../../App.css";
import PermissionDenied from '../../utils/permission_denied';
import { Country, State, City } from 'country-state-city';
import { COUNTRY_CODES } from '../../constants/COUNTRY_CODES';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AuthHelper } from '../../utils/authHelper';
import { useUser } from '../../contexts/UserContext';

const BulkPurchasePage = () => {

    const navigate = useNavigate();

    const {permissions } = useUser();

    console.log("permissons=>",permissions)

    // State declarations
    const [multiInsertRows, setMultiInsertRows] = useState([{
        vendor_id: "",
        book_id: "",
        quantity: 1,
        unit_price: 0,
        purchase_date: new Date().toISOString().split('T')[0],
        notes: "",
        bill_number: ""
    }]);

    const [showInvoiceModal, setShowInvoiceModal] = useState(false);
    const [showVendorSlipModal, setShowVendorSlipModal] = useState(false);
    const [selectedVendorForSlip, setSelectedVendorForSlip] = useState(null);
    const [selectedVendor, setSelectedVendor] = useState(null);
    const [vendors, setVendors] = useState([]);
    const [books, setBooks] = useState([]);
    const [saving, setSaving] = useState(false);
    const [activeTab, setActiveTab] = useState("single");
    const [selectedFile, setSelectedFile] = useState(null);
    const [barcodeInput, setBarcodeInput] = useState("");
    const [loading, setLoading] = useState(false);
    const [stats, setStats] = useState({
        issued: 0,
        purchased: 0,
        available: 0
    });
    const [showAddVendorModal, setShowAddVendorModal] = useState(false);
    const [showAddBookModal, setShowAddBookModal] = useState(false);
    const [authors, setAuthors] = useState([]);
    const [categories, setCategories] = useState([]);
    const [publishers, setPublishers] = useState([]);
    const [autoLookupTimeout, setAutoLookupTimeout] = useState(null);
    const [barcodeProcessing, setBarcodeProcessing] = useState(false);
    const [company, setCompany] = useState("");

    // New state for payment module permission
    const [hasPaymentPermission, setHasPaymentPermission] = useState(false);
    const [paymentModuleId, setPaymentModuleId] = useState(null);
    const [permissionCheckComplete, setPermissionCheckComplete] = useState(false);

    const [vendorFormData, setVendorFormData] = useState({
        name: "",
        company_name: "",
        email: "",
        phone: "",
        country_code: "+91",
        gst_number: "",
        pan_number: "",
        address: "",
        city: "",
        state: "",
        pincode: "",
        country: "India",
        status: true,
    });

    const [bookFormData, setBookFormData] = useState({
        title: "",
        author_id: "",
        classification_id: "",
        classification_label: "",
        classification_category: "",
        classification_type: "",
        classification_from: "",
        classification_to: "",
        classification_code: "",
        publisher_id: "",
        isbn: "",
        inventory_binding: "",
        edition: "",
        publication_year: "",
        pages: "",
        language: "",
        min_age: "",
        status: "ACTIVE",
        is_book_bank: false,
        suggested_rack_mapping_id: "",
    });

    const GOOGLE_BOOKS_API_KEY = "AIzaSyAC2OqFGAIdOaCSWswm-mjiwoY-kzPJT-0";

    // Helper function to get company ID from token
    function getCompanyIdFromToken() {
        const token = sessionStorage.getItem("token");
        if (!token) return null;
        try {
            const payload = JSON.parse(atob(token.split(".")[1]));
            return payload.companyid || payload.company_id || null;
        } catch (error) {
            console.error("Error parsing token:", error);
            return null;
        }
    }

    // Helper function to get user role from token
    function getUserRoleFromToken() {
        const token = sessionStorage.getItem("token");
        console.log("token",token);
        if (!token) return null;
        try {
            const payload = JSON.parse(atob(token.split(".")[1]));
            console.log("payload",payload);
            return payload.role || payload.role_name || null;
        } catch (error) {
            console.error("Error parsing token:", error);
            return null;
        }
    }





    // Fetch company data
    const fetchCompany = async () => {
        try {
            const companyid = getCompanyIdFromToken();
            if (!companyid) {
                console.error("Company ID not found in token");
                return;
            }
            const companyApi = new DataApi("company");
            const response = await companyApi.fetchById(companyid);
            if (response.data) {
                setCompany(response.data);
            }
        } catch (error) {
            console.error("Error fetching company by ID:", error);
        }
    };

    // Fetch stats
    const fetchStats = async () => {
        try {
            const issuedApi = new DataApi("bookissue");
            const issuedResponse = await issuedApi.fetchAll();

            const purchaseApi = new DataApi("purchase");
            const purchaseResponse = await purchaseApi.fetchAll();

            const bookApi = new DataApi("book/active");
            const bookResponse = await bookApi.fetchAll();

            let currentIssuedCount = 0;
            let purchasedCount = 0;
            let availableCount = 0;

            const issuedData = Array.isArray(issuedResponse.data) ? issuedResponse.data : (issuedResponse.data?.data || []);
            if (issuedData.length > 0) {
                currentIssuedCount = issuedData.filter(issue =>
                    issue.status && issue.status.toLowerCase() === "issued"
                ).length;
            }

            const purchaseData = Array.isArray(purchaseResponse.data) ? purchaseResponse.data : (purchaseResponse.data?.data || []);
            if (purchaseData.length > 0) {
                purchasedCount = purchaseData.reduce((sum, purchase) =>
                    sum + (parseInt(purchase.quantity) || 0), 0);
            }

            const bookDataArr = Array.isArray(bookResponse.data) ? bookResponse.data : (bookResponse.data?.data || []);
            if (bookDataArr.length > 0) {
                availableCount = bookDataArr.reduce((sum, book) =>
                    sum + (parseInt(book.available_copies) || 0), 0);
            }

            setStats({
                issued: currentIssuedCount,
                purchased: purchasedCount,
                available: availableCount,
            });

        } catch (error) {
            console.error("Error fetching stats:", error);
        }
    };

    // Fetch vendors
    const fetchVendors = async () => {
        try {
            const vendorApi = new DataApi("vendor/active");
            const response = await vendorApi.fetchAll();
            if (response.data) {
                const vendorData = Array.isArray(response.data) ? response.data : (response.data.data || []);
                setVendors(vendorData);
            }
        } catch (error) {
            console.error("Error fetching vendors:", error);
        }
    };

    // Fetch books
    const fetchBooks = async () => {
        try {
            const bookApi = new DataApi("book/active");
            const response = await bookApi.fetchAll();
            if (response.data) {
                const bookData = Array.isArray(response.data) ? response.data : (response.data.data || []);
                setBooks(bookData);
            }
        } catch (error) {
            console.error("Error fetching books:", error);
        }
    };

    // Fetch authors
    const fetchAuthors = async () => {
        try {
            const authorApi = new DataApi("author");
            const response = await authorApi.fetchAll();
            if (response.data) {
                setAuthors(response.data);
            }
        } catch (error) {
            console.error("Error fetching authors:", error);
        }
    };

    // Fetch categories
    const fetchCategories = async () => {
        try {
            const categoryApi = new DataApi("category");
            const response = await categoryApi.fetchAll();
            if (response.data) {
                setCategories(response.data);
            }
        } catch (error) {
            console.error("Error fetching categories:", error);
        }
    };

    // Fetch publishers
    const fetchPublishers = async () => {
        try {
            const publisherApi = new DataApi("publisher");
            const response = await publisherApi.fetchAll();
            if (response.data) {
                setPublishers(Array.isArray(response.data) ? response.data : (response.data.data || []));
            }
        } catch (error) {
            console.error("Error fetching publishers:", error);
        }
    };

    // Check payment permission for System Admin
    const checkPaymentPermission = () => {
        try {
            const role = getUserRoleFromToken()?.toLowerCase();

            console.log("role=>",role);
            // ✅ Admin override
            if (role === "system admin" || role === "admin") {
                setHasPaymentPermission(true);
                return;
            }

            const paymentModule = permissions.find(
                (p) => p.moduleName === "Payment"
            );

            console.log("paymentModule=>",paymentModule);

            setHasPaymentPermission(paymentModule?.allowView);

        } catch (error) {
            console.error(error);
            setHasPaymentPermission(false);
        }
    };



    // Initial data fetch
    useEffect(() => {
        const initializeData = async () => {
            setLoading(true);
            try {
                await Promise.all([
                    fetchCompany(),
                    fetchVendors(),
                    fetchBooks(),
                    fetchAuthors(),
                    fetchCategories(),
                    fetchPublishers(),
                    fetchStats()
                ]);

                // Run permission check after other data is loaded
                await checkPaymentPermission();

                // Optional: Run debug to see structure (remove in production)
                // await debugPermissionsStructure();

            } catch (error) {
                console.error("Error initializing data:", error);
                toast.error("Failed to load initial data");
            } finally {
                setLoading(false);
            }
        };

        initializeData();
    }, []);

    // Reset book form when modal opens
    useEffect(() => {
        if (showAddBookModal) {
            setBookFormData({
                title: "",
                author_id: "",
                classification_id: "",
                classification_label: "",
                classification_category: "",
                classification_type: "",
                classification_from: "",
                classification_to: "",
                classification_code: "",
                publisher_id: "",
                isbn: barcodeInput || "",
                inventory_binding: "",
                edition: "",
                publication_year: "",
                pages: "",
                language: "",
                min_age: "",
                status: "ACTIVE",
                is_book_bank: false,
                suggested_rack_mapping_id: "",
            });
        }
    }, [showAddBookModal, barcodeInput]);

    // Options for selects
    const vendorOptions = vendors.map((vendor) => ({
        value: vendor.id,
        label: vendor.name
    }));

    const bookOptions = books.map((book) => ({
        value: book.id,
        label: `${book.title}${book.isbn ? ` (${book.isbn})` : ''}`
    }));

    const authorOptions = authors.map((author) => ({
        value: author.id,
        label: author.name
    }));

    const categoryOptions = categories.map((category) => ({
        value: category.id,
        label: category.name
    }));

    const publisherOptions = publishers.map((p) => ({
        value: String(p.id),
        label: p.name
    }));

    // Helper functions for selects
    const getSelectedAuthor = () => {
        if (!bookFormData.author_id) return null;
        return authorOptions.find(option => option.value === bookFormData.author_id) || null;
    };

    const getSelectedBook = (rowIndex) => {
        const row = multiInsertRows[rowIndex];
        if (!row.book_id) return null;
        return bookOptions.find(option => option.value === row.book_id) || null;
    };

    const getSelectedVendorForRow = (rowIndex) => {
        const row = multiInsertRows[rowIndex];
        if (!row.vendor_id) return null;
        return vendorOptions.find(option => option.value === row.vendor_id) || null;
    };

    // Handle file change for import
    const handleFileChange = (file) => {
        if (file) {
            setSelectedFile(file);
        } else {
            setSelectedFile(null);
        }
    };

    // ISBN validation
    const isValidISBN = (isbn) => {
        if (!isbn) return false;
        const cleanIsbn = isbn.replace(/[^\dX]/gi, '').toUpperCase();
        if (cleanIsbn.length === 10) {
            const isbn10Regex = /^[\d]{9}[\dX]$/;
            if (isbn10Regex.test(cleanIsbn)) {
                return { type: 'isbn10', value: cleanIsbn };
            }
        }
        if (cleanIsbn.length === 13) {
            const isbn13Regex = /^[\d]{13}$/;
            if (isbn13Regex.test(cleanIsbn)) {
                return { type: 'isbn13', value: cleanIsbn };
            }
        }
        return false;
    };

    // Fetch book by ISBN from Google Books API
    const fetchBookByISBN = async (isbn) => {
        const bookData = {
            isbn: isbn,
            title: "",
            total_copies: 1,
            available_copies: 1,
            language: "English"
        };

        try {
            const googleBooksUrl = `https://www.googleapis.com/books/v1/volumes?q=isbn:${isbn}&key=${GOOGLE_BOOKS_API_KEY}`;
            const googleResponse = await fetch(googleBooksUrl);

            if (googleResponse.ok) {
                const data = await googleResponse.json();
                if (data.items && data.items.length > 0) {
                    const volumeInfo = data.items[0].volumeInfo;
                    bookData.title = volumeInfo.title || "";

                    if (volumeInfo.authors && volumeInfo.authors.length > 0) {
                        bookData.author_name = volumeInfo.authors.join(", ");
                    }

                    if (volumeInfo.categories && volumeInfo.categories.length > 0) {
                        const category = volumeInfo.categories[0];
                        bookData.category_name = category.split("/")[0].split(",")[0].trim();
                    }

                    if (volumeInfo.language) {
                        bookData.language = volumeInfo.language.toUpperCase();
                    }

                    if (volumeInfo.publishedDate) {
                        bookData.published_date = volumeInfo.publishedDate;
                    }

                    if (volumeInfo.publisher) {
                        bookData.publisher = volumeInfo.publisher;
                    }

                    if (volumeInfo.pageCount) {
                        bookData.page_count = volumeInfo.pageCount;
                    }

                    return bookData;
                }
            }
        } catch (error) {
            console.error("Error fetching from Google Books:", error);
        }
        return bookData;
    };

    // Find or create author
    const findOrCreateAuthor = async (authorName) => {
        try {
            const authorApi = new DataApi("author");
            const authorsResponse = await authorApi.fetchAll();

            if (authorsResponse.data && Array.isArray(authorsResponse.data)) {
                const authorNames = authorName.split(",").map(a => a.trim());
                const primaryAuthorName = authorNames[0];

                let foundAuthor = authorsResponse.data.find(a =>
                    a.name && a.name.toLowerCase() === primaryAuthorName.toLowerCase()
                );

                if (!foundAuthor) {
                    const authorData = {
                        name: primaryAuthorName,
                        email: "",
                        bio: ""
                    };

                    const newAuthorResponse = await authorApi.create(authorData);
                    if (newAuthorResponse.data) {
                        foundAuthor = newAuthorResponse.data;
                        toast.success(`Author "${primaryAuthorName}" created successfully`);
                        await fetchAuthors();
                    }
                }

                if (foundAuthor) {
                    return foundAuthor.id;
                }
            }
        } catch (error) {
            console.error("Error finding/creating author:", error);
        }
        return null;
    };

    // Find or create category
    const findOrCreateCategory = async (categoryName) => {
        try {
            const categoryApi = new DataApi("category");
            const categoriesResponse = await categoryApi.fetchAll();

            if (categoriesResponse.data && Array.isArray(categoriesResponse.data)) {
                let foundCategory = categoriesResponse.data.find(c =>
                    c.name && c.name.toLowerCase() === categoryName.toLowerCase()
                );

                if (!foundCategory) {
                    const categoryData = {
                        name: categoryName,
                        description: ""
                    };

                    const newCategoryResponse = await categoryApi.create(categoryData);
                    if (newCategoryResponse.data) {
                        foundCategory = newCategoryResponse.data;
                        toast.success(`Category "${categoryName}" created successfully`);
                        await fetchCategories();
                    }
                }

                if (foundCategory) {
                    return foundCategory.id;
                }
            }
        } catch (error) {
            console.error("Error finding/creating category:", error);
        }
        return null;
    };

    // Process barcode data
    const processBarcodeData = async (barcode) => {
        if (!barcode || barcode.trim().length === 0) return null;

        setBarcodeProcessing(true);
        try {
            const isbnCheck = isValidISBN(barcode);
            if (isbnCheck) {
                const isbn = isbnCheck.value;
                const bookData = await fetchBookByISBN(isbn);

                let authorId = null;
                if (bookData.author_name) {
                    authorId = await findOrCreateAuthor(bookData.author_name);
                }

                let categoryId = null;
                if (bookData.category_name) {
                    categoryId = await findOrCreateCategory(bookData.category_name);
                }

                return {
                    title: bookData.title || "",
                    author_id: authorId || "",
                    category_id: categoryId || "",
                    isbn: isbn,
                    language: bookData.language || "English",
                };
            }
            return null;
        } catch (error) {
            console.error("Error processing barcode data:", error);
            return null;
        } finally {
            setBarcodeProcessing(false);
        }
    };

    // Handle barcode lookup
    const handleBarcodeLookup = async (barcode) => {
        if (!barcode.trim()) {
            toast.error("Please enter a barcode/ISBN");
            return;
        }

        try {
            setLoading(true);
            const processedData = await processBarcodeData(barcode.trim());

            if (processedData) {
                setBookFormData(prev => ({
                    ...prev,
                    ...processedData
                }));
                setBarcodeInput(processedData.isbn || barcode);
                toast.success(`Book data loaded: ${processedData.title}`);
            } else {
                setBookFormData(prev => ({
                    ...prev,
                    isbn: barcode,
                }));
                toast.info("Could not auto-detect book details. Please fill manually.");
            }
        } catch (error) {
            console.error('Barcode lookup error:', error);
            toast.error("Failed to process barcode");
        } finally {
            setLoading(false);
        }
    };

    // Handle barcode scanned
    const handleBarcodeScanned = (barcode) => {
        setBarcodeInput(barcode);
        setTimeout(() => {
            handleBarcodeLookup(barcode);
        }, 500);
    };

    // Handle multi row change
    const handleMultiRowChange = (index, field, value) => {
        const updatedRows = [...multiInsertRows];
        if (field === "quantity" || field === "unit_price") {
            value = Math.floor(Number(value));
        }
        updatedRows[index] = { ...updatedRows[index], [field]: value };
        setMultiInsertRows(updatedRows);
    };

    // Add new row
    const handleAddBookRow = () => {
        const newRow = {
            vendor_id: activeTab === "single" ? (selectedVendor ? selectedVendor.value : "") : "",
            book_id: "",
            quantity: 1,
            unit_price: 0,
            purchase_date: new Date().toISOString().split('T')[0],
            notes: "",
            bill_number: ""
        };
        setMultiInsertRows([...multiInsertRows, newRow]);
    };

    // Remove row
    const handleRemoveRow = (index) => {
        if (multiInsertRows.length > 1) {
            const updatedRows = multiInsertRows.filter((_, i) => i !== index);
            setMultiInsertRows(updatedRows);
        }
    };

    // Handle vendor change
    const handleVendorChange = (selectedOption) => {
        setSelectedVendor(selectedOption);
        if (activeTab === "single") {
            const vendorId = selectedOption ? selectedOption.value : "";
            const updatedRows = multiInsertRows.map(row => ({
                ...row,
                vendor_id: vendorId
            }));
            setMultiInsertRows(updatedRows);
        }
    };

    // Add vendor
    const handleAddVendor = async () => {
        if (!vendorFormData.name?.trim()) {
            toast.error("Vendor name is required");
            return;
        }

        try {
            setLoading(true);
            const vendorApi = new DataApi("vendor");
            const response = await vendorApi.create(vendorFormData);

            if (response?.data) {
                toast.success("Vendor added successfully");
                setShowAddVendorModal(false);
                setVendorFormData({
                    name: "",
                    company_name: "",
                    email: "",
                    phone: "",
                    country_code: "+91",
                    gst_number: "",
                    pan_number: "",
                    address: "",
                    city: "",
                    state: "",
                    pincode: "",
                    country: "India",
                    status: true,
                });
                await fetchVendors();
            } else {
                toast.error("Something went wrong while adding vendor");
            }
        } catch (error) {
            console.error("Error adding vendor:", error);
            toast.error(error?.response?.data?.message || "Failed to add vendor");
        } finally {
            setLoading(false);
        }
    };

    // Add book
    const handleAddBook = async () => {
        if (!bookFormData.title?.trim()) {
            toast.error("Book title is required");
            return;
        }
        if (!bookFormData.author_id) {
            toast.error("Author is required");
            return;
        }
        if (!bookFormData.classification_id) {
            toast.error("Classification is required");
            return;
        }
        if (!bookFormData.isbn?.trim()) {
            toast.error("ISBN/ISSN is required");
            return;
        }
        if (bookFormData.min_age === "" || bookFormData.min_age === undefined) {
            toast.error("Min Age is required");
            return;
        }

        try {
            setLoading(true);
            const bookApi = new DataApi("book");
            const bookDataToSend = {
                title: bookFormData.title.trim(),
                author_id: bookFormData.author_id,
                classification_id: bookFormData.classification_id,
                publisher_id: bookFormData.publisher_id || null,
                isbn: bookFormData.isbn.trim(),
                inventory_binding: bookFormData.inventory_binding || null,
                edition: bookFormData.edition || null,
                publication_year: bookFormData.publication_year || null,
                pages: bookFormData.pages || null,
                language: bookFormData.language || "English",
                min_age: bookFormData.min_age,
                status: bookFormData.status || "ACTIVE",
                is_book_bank: bookFormData.is_book_bank || false,
                suggested_rack_mapping_id: bookFormData.suggested_rack_mapping_id || null,
            };

            const response = await bookApi.create(bookDataToSend);
            if (response && response.data) {
                await fetchBooks();
                toast.success("Book added successfully");
                setShowAddBookModal(false);
                setBarcodeInput("");
            } else {
                toast.error("Failed to add book");
            }
        } catch (error) {
            console.error("Error adding book:", error);
            toast.error(error.message || "Failed to add book");
        } finally {
            setLoading(false);
        }
    };

    // Save purchases with invoice data
    const handleSavePurchases = async () => {
        const validationErrors = [];
        multiInsertRows.forEach((row, index) => {
            const missingFields = [];
            if (!row.vendor_id) missingFields.push("Vendor");
            if (!row.book_id) missingFields.push("Book");
            if (!row.quantity || row.quantity <= 0) missingFields.push("Quantity");
            if (!row.unit_price || row.unit_price <= 0) missingFields.push("Unit Price");

            if (missingFields.length > 0) {
                validationErrors.push(`Row ${index + 1}: Missing ${missingFields.join(", ")}`);
            }
        });

        if (validationErrors.length > 0) {
            toast.error(validationErrors.join("; "));
            return;
        }

// Prepare data with invoice information only if user has payment permission
        const convertedData = multiInsertRows.map((row) => ({
            vendor_id: row.vendor_id,
            book_id: row.book_id,
            status: 'active',
            quantity: parseInt(row.quantity) || 1,
            unit_price: parseFloat(row.unit_price) || 0,
            purchase_date: row.purchase_date || new Date().toISOString().split('T')[0],
            notes: row.notes || "",
            bill_number: row.bill_number || "",
            total_amount: (parseInt(row.quantity) || 1) * (parseFloat(row.unit_price) || 0),

            // Invoice specific fields - only include if user has payment permission
            ...(hasPaymentPermission && {
                invoice_status: 'UNPAID',
                invoice_notes: `Auto-generated invoice for purchase of ${row.quantity} book(s)`,
                create_invoice: true
            })
        }));

        if (convertedData.length === 0) {
            toast.error("Please fill at least one complete purchase entry");
            return;
        }

        try {
            setSaving(true);
            const purchaseApi = new DataApi("purchase");
            const bookCopyApi = new DataApi("book-copy");
            let successCount = 0;
            const createdInvoices = [];

            for (let i = 0; i < convertedData.length; i++) {
                const purchaseData = convertedData[i];
                try {
                    const purchaseResponse = await purchaseApi.create(purchaseData);

                    if (purchaseResponse.data) {

                        if (hasPaymentPermission && purchaseResponse.data.invoice) {
                            createdInvoices.push(purchaseResponse.data.invoice);
                        }

                        try {
                            await bookCopyApi.post('/bulk', {
                                book_id: purchaseData.book_id,
                                quantity: purchaseData.quantity,
                                item_price: purchaseData.unit_price
                            });
                        } catch (copyErr) {
                            console.error("Error creating copies:", copyErr);
                        }

                        successCount++;
                    }
                } catch (error) {
                    console.error("Error creating purchase:", error);
                    toast.error(`Row ${i + 1}: ${error.response?.data?.error || error.message}`);
                }
            }

            if (successCount > 0) {
                toast.success(`Successfully created ${successCount} purchase(s)`);

                if (hasPaymentPermission && createdInvoices.length > 0) {
                    toast.success(`Created ${createdInvoices.length} invoice(s)`);
                }

                // Reset form
                setMultiInsertRows([{
                    vendor_id: "",
                    book_id: "",
                    quantity: 1,
                    unit_price: 0,
                    purchase_date: new Date().toISOString().split('T')[0],
                    notes: "",
                    bill_number: ""
                }]);
                setSelectedVendor(null);

                navigate('/purchase');
            }
        } catch (error) {
            console.error("Error in bulk insert:", error);
            toast.error(error.response?.data?.error || error.message || "Failed to save purchases");
        } finally {
            setSaving(false);
        }
    };

    // Generate vendor slip HTML
    const generateVendorSlipHTML = (vendorId) => {
        const vendorRows = multiInsertRows.filter(r => r.vendor_id === vendorId);
        const vendorName = vendorOptions.find(v => v.value === vendorId)?.label || "Unknown Vendor";
        const vendorTotal = vendorRows.reduce((sum, r) => sum + ((parseFloat(r.quantity) || 0) * (parseFloat(r.unit_price) || 0)), 0);
        const vendorData = vendors.find(v => v.id === vendorId);

        return `
            <div style="padding: 30px; font-family: Arial, sans-serif; max-width: 800px; margin: 0 auto;">
                <!-- Header -->
                <div style="display: flex; justify-content: space-between; margin-bottom: 30px; border-bottom: 3px solid var(--primary-color, #8b5cf6); padding-bottom: 20px;">
                    <div>
                        <h2 style="color: var(--primary-color, #8b5cf6); margin: 0;">${company?.name || "Library"}</h2>
                        <p style="margin: 5px 0; color: #666;">${company?.address || ""}</p>
                        <p style="margin: 5px 0; color: #666;">${company?.email || ""} ${company?.phone ? `| ${company.phone}` : ""}</p>
                    </div>
                    <div style="text-align: right;">
                        <h3 style="color: var(--primary-color, #8b5cf6); margin: 0;">VENDOR SLIP</h3>
                        <p style="margin: 5px 0;"><strong>Date:</strong> ${new Date().toLocaleDateString('en-IN')}</p>
                    </div>
                </div>

                <!-- Vendor Info -->
                <div style="margin-bottom: 30px; border: 1px solid #dee2e6; border-radius: 8px; overflow: hidden;">
                    <div style="background-color: #f8f9fa; padding: 15px 20px; border-bottom: 1px solid #dee2e6;">
                        <h4 style="margin: 0; color: #333;">
                            <i class="fa-solid fa-store" style="margin-right: 10px;"></i>${vendorName}
                        </h4>
                    </div>
                    <div style="padding: 15px 20px; display: grid; grid-template-columns: repeat(2, 1fr); gap: 15px;">
                        ${vendorData?.company_name ? `
                        <div>
                            <strong style="color: #666; font-size: 12px;">COMPANY NAME</strong>
                            <div style="margin-top: 5px;">${vendorData.company_name}</div>
                        </div>
                        ` : ''}
                        ${vendorData?.email ? `
                        <div>
                            <strong style="color: #666; font-size: 12px;">EMAIL</strong>
                            <div style="margin-top: 5px;">${vendorData.email}</div>
                        </div>
                        ` : ''}
                        ${vendorData?.phone ? `
                        <div>
                            <strong style="color: #666; font-size: 12px;">PHONE</strong>
                            <div style="margin-top: 5px;">${vendorData.country_code || ''} ${vendorData.phone}</div>
                        </div>
                        ` : ''}
                        ${vendorData?.gst_number ? `
                        <div>
                            <strong style="color: #666; font-size: 12px;">GST NO.</strong>
                            <div style="margin-top: 5px;">${vendorData.gst_number}</div>
                        </div>
                        ` : ''}
                        ${vendorData?.address || vendorData?.city || vendorData?.state ? `
                        <div style="grid-column: span 2;">
                            <strong style="color: #666; font-size: 12px;">ADDRESS</strong>
                            <div style="margin-top: 5px;">
                                ${vendorData.address || ''}${vendorData.city ? `, ${vendorData.city}` : ''}${vendorData.state ? `, ${vendorData.state}` : ''}${vendorData.pincode ? ` - ${vendorData.pincode}` : ''}
                            </div>
                        </div>
                        ` : ''}
                    </div>
                </div>

                <!-- Items Table -->
                <table style="width: 100%; border-collapse: collapse; margin-bottom: 30px; border: 1px solid #dee2e6; border-radius: 8px; overflow: hidden;">
                    <thead>
                        <tr style="background-color: #f8f9fa; border-bottom: 2px solid #dee2e6;">
                            <th style="padding: 12px 15px; text-align: left; width: 5%;">#</th>
                            <th style="padding: 12px 15px; text-align: left; width: 35%;">Book Title</th>
                            <th style="padding: 12px 15px; text-align: center; width: 15%;">Purchase Date</th>
                            <th style="padding: 12px 15px; text-align: center; width: 10%;">Qty</th>
                            <th style="padding: 12px 15px; text-align: right; width: 15%;">Unit Price</th>
                            <th style="padding: 12px 15px; text-align: right; width: 15%;">Amount</th>
                            <th style="padding: 12px 15px; text-align: left; width: 15%;">Bill No.</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${vendorRows.map((row, idx) => {
            const bookLabel = bookOptions.find(b => b.value === row.book_id)?.label || "—";
            const amount = (parseFloat(row.quantity) || 0) * (parseFloat(row.unit_price) || 0);
            return `
                                <tr style="border-bottom: 1px solid #f0f0f0; background-color: ${idx % 2 === 0 ? 'white' : '#fafafa'};">
                                    <td style="padding: 12px 15px;">${idx + 1}</td>
                                    <td style="padding: 12px 15px;">${bookLabel}</td>
                                    <td style="padding: 12px 15px; text-align: center;">${row.purchase_date}</td>
                                    <td style="padding: 12px 15px; text-align: center;">${row.quantity}</td>
                                    <td style="padding: 12px 15px; text-align: right;">${company?.currency || "₹"} ${parseFloat(row.unit_price || 0).toFixed(2)}</td>
                                    <td style="padding: 12px 15px; text-align: right; font-weight: 600; color: var(--primary-color, #8b5cf6);">${company?.currency || "₹"} ${amount.toFixed(2)}</td>
                                    <td style="padding: 12px 15px; text-align: left; font-size: 13px; color: #666;">${row.bill_number || "—"}</td>
                                </tr>
                            `;
        }).join('')}
                    </tbody>
                    <tfoot>
                        <tr style="background-color: #f8f9fa; border-top: 2px solid #dee2e6;">
                            <td colspan="3" style="padding: 12px 15px; text-align: right;"><strong>Subtotal:</strong></td>
                            <td style="padding: 12px 15px; text-align: center;"><strong>${vendorRows.reduce((sum, r) => sum + (parseInt(r.quantity) || 0), 0)}</strong></td>
                            <td colspan="2" style="padding: 12px 15px; text-align: right;"><strong>${company?.currency || "₹"} ${vendorTotal.toFixed(2)}</strong></td>
                            <td></td>
                        </tr>
                    </tfoot>
                </table>

                <!-- Footer -->
                <div style="margin-top: 40px; padding-top: 20px; border-top: 1px solid #dee2e6; display: flex; justify-content: space-between; color: #888; font-size: 13px;">
                    <span>Generated on ${new Date().toLocaleString('en-IN')}</span>
                    <span>This is a computer-generated vendor slip</span>
                </div>
            </div>
        `;
    };

    // Print vendor slip
    const printVendorSlip = (vendorId) => {
        const vendorName = vendorOptions.find(v => v.value === vendorId)?.label || "Vendor";
        const printContent = generateVendorSlipHTML(vendorId);
        const printWindow = window.open('', '_blank');
        printWindow.document.write(`
            <html>
            <head>
                <title>${vendorName} - Purchase Slip</title>
                <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css">
                <style>
                    body { font-family: Arial, sans-serif; margin: 20px; }
                    table { width: 100%; border-collapse: collapse; }
                    th, td { padding: 10px 15px; }
                    thead tr { background: #f8f9fa; }
                    @media print {
                        body { margin: 0; }
                        button { display: none; }
                    }
                </style>
            </head>
            <body>${printContent}</body>
            </html>
        `);
        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
    };

    // Download vendor slip as PDF - FIXED VERSION
    const downloadVendorSlip = (vendorId) => {
        const vendorName = vendorOptions.find(v => v.value === vendorId)?.label || "Vendor";
        const printContent = generateVendorSlipHTML(vendorId);

        // Create a blob with the HTML content
        const blob = new Blob([`
            <html>
            <head>
                <title>${vendorName} - Purchase Slip</title>
                <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css">
                <style>
                    body { font-family: Arial, sans-serif; margin: 20px; }
                    table { width: 100%; border-collapse: collapse; }
                    th, td { padding: 10px 15px; }
                    thead tr { background: #f8f9fa; }
                    @media print {
                        body { margin: 0; }
                    }
                </style>
            </head>
            <body>${printContent}</body>
            </html>
        `], { type: 'text/html' });

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${vendorName.replace(/\s+/g, '_')}_Purchase_Slip_${new Date().toISOString().split('T')[0]}.html`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);

    };

    // Handle vendor slip action
    const handleVendorSlipAction = (vendorId, action) => {
        if (action === 'print') {
            printVendorSlip(vendorId);
        } else if (action === 'download') {
            downloadVendorSlip(vendorId);
        } else if (action === 'view') {
            setSelectedVendorForSlip(vendorId);
            setShowVendorSlipModal(true);
        }
    };

    const getUniqueVendors = () => {
        const vendorIds = [...new Set(multiInsertRows.map(r => r.vendor_id).filter(Boolean))];
        return vendorIds.map(id => {
            const vendorRows = multiInsertRows.filter(r => r.vendor_id === id);
            const vendorTotal = vendorRows.reduce((sum, r) => sum + ((parseFloat(r.quantity) || 0) * (parseFloat(r.unit_price) || 0)), 0);
            const totalQty = vendorRows.reduce((sum, r) => sum + (parseInt(r.quantity) || 0), 0);
            return {
                id,
                name: vendorOptions.find(v => v.value === id)?.label || "Unknown Vendor",
                rows: vendorRows,
                total: vendorTotal,
                quantity: totalQty
            };
        });
    };

    const totalAmount = multiInsertRows.reduce((sum, row) =>
        sum + ((parseFloat(row.quantity) || 0) * (parseFloat(row.unit_price) || 0)), 0);
    const uniqueVendors = [...new Set(multiInsertRows.map(row => row.vendor_id).filter(Boolean))];
    const totalBooks = multiInsertRows.reduce((sum, row) => sum + (parseInt(row.quantity) || 0), 0);
    const todayStr = new Date().toISOString().split("T")[0];

    // Permission check
    const purchasePermission = Array.isArray(permissions)
        ? permissions.find(p => p.moduleName === "Purchases")
        : permissions;

    if (!purchasePermission?.allowCreate) {
        return <PermissionDenied />;
    }
    // Render loading
    if (loading) {
        return (
            <Container fluid className="py-3" style={{ backgroundColor: '#f5f7fb', minHeight: '100vh' }}>
                <div className="text-center py-5">
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-3">Loading data...</p>
                </div>
            </Container>
        );
    }

    // Render tab content
    const renderTabContent = () => {
        switch (activeTab) {
            case "single":
                return (
                    <>
                        <Row className="align-items-center mb-4">
                            <Col lg={8}>
                                <Form.Group>
                                    <Form.Label className="fw-bold mb-2">
                                        Select Default Vendor<span className="text-danger">*</span>
                                    </Form.Label>
                                    <Select
                                        value={selectedVendor}
                                        onChange={handleVendorChange}
                                        options={vendorOptions}
                                        placeholder="Choose default vendor for all rows..."
                                        isClearable
                                        isSearchable
                                        menuPlacement="auto"
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                minHeight: "45px",
                                                fontSize: "16px",
                                                border: "2px solid var(--primary-color)",
                                                borderRadius: "8px",
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                zIndex: 9999,
                                            }),
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999
                                            })
                                        }}
                                        menuPortalTarget={document.body}
                                    />
                                </Form.Group>
                            </Col>
                            <Col lg={2}></Col>
                            <Col lg={2} className="d-flex justify-content-end">
                                <button
                                    className="custom-btn-primary"
                                    onClick={handleAddBookRow}
                                >
                                    <i className="fa-solid fa-plus me-1"></i>
                                    Add New Row
                                </button>
                            </Col>
                        </Row>

                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h6 className="mb-0">
                                Purchase Items ({multiInsertRows.length})
                            </h6>
                        </div>

                        <div className="border rounded" style={{
                            overflow: 'auto',
                            backgroundColor: 'white',
                            width: '100%',
                            position: 'relative',
                            zIndex: 1
                        }}>
                            <div style={{
                                minWidth: '1200px',
                                width: '100%',
                                position: 'relative',
                                zIndex: 1
                            }}>
                                <Table bordered hover className="mb-0" style={{ width: '100%', tableLayout: 'fixed' }}>
                                    <thead style={{
                                        position: 'sticky',
                                        top: 0,
                                        zIndex: 10,
                                        backgroundColor: '#f8f9fa'
                                    }}>
                                        <tr>
                                            <th style={{ background: 'var(--primary-background-color)', width: '3%' }}>
                                                <span>Vendor</span>
                                                <span className="text-danger ms-1">*</span>
                                            </th>
                                            <th style={{ background: 'var(--primary-background-color)', width: '3%' }}>
                                                <div className="d-flex align-items-center">
                                                    <span>Book</span>
                                                    <span className="text-danger ms-1">*</span>
                                                </div>
                                            </th>
                                            <th style={{ background: 'var(--primary-background-color)', width: '2%' }}>
                                                <div className="d-flex align-items-center">
                                                    <span>Qty</span>
                                                    <span className="text-danger ms-1">*</span>
                                                </div>
                                            </th>
                                            <th style={{ background: 'var(--primary-background-color)', width: '2%' }}>
                                                <div className="d-flex align-items-center">
                                                    <span>Unit Price</span>
                                                    <span className="text-danger ms-1">*</span>
                                                </div>
                                            </th>
                                            <th style={{ background: 'var(--primary-background-color)', width: '2%' }}>
                                                <div className="text-center">Total Amount</div>
                                            </th>
                                            <th style={{ background: 'var(--primary-background-color)', width: '3%' }}>
                                                <div>Purchase Date</div>
                                            </th>
                                            <th style={{ background: 'var(--primary-background-color)', width: '3%' }}>
                                                <div>Bill Number</div>
                                            </th>
                                            <th style={{ background: 'var(--primary-background-color)', width: '3%' }}>
                                                <div>Notes</div>
                                            </th>
                                            <th style={{ background: 'var(--primary-background-color)', width: '1%' }}>
                                                <div>Actions</div>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {multiInsertRows.map((row, index) => (
                                            <tr key={index} className={index % 2 === 0 ? 'table-row-light' : ''}>
                                                <td className="border-end p-2" style={{ width: '22%' }}>
                                                    <div className="d-flex gap-1 align-items-center">
                                                        <div className="flex-grow-1" style={{ minWidth: '0' }}>
                                                            <Select
                                                                value={getSelectedVendorForRow(index)}
                                                                onChange={(selectedOption) => handleMultiRowChange(index, "vendor_id", selectedOption ? selectedOption.value : "")}
                                                                options={vendorOptions}
                                                                placeholder="Select Vendor"
                                                                isClearable
                                                                isSearchable
                                                                menuPlacement="auto"
                                                                styles={{
                                                                    control: (base, state) => ({
                                                                        ...base,
                                                                        width: "100%",
                                                                        minHeight: "36px",
                                                                        fontSize: "14px",
                                                                        borderColor: state.isFocused ? "var(--primary-color)" : row.vendor_id ? "#28a745" : "#dee2e6",
                                                                        backgroundColor: row.vendor_id ? "#f8fff9" : "white",
                                                                    }),
                                                                    menu: (base) => ({
                                                                        ...base,
                                                                        zIndex: 9999,
                                                                    }),
                                                                    menuPortal: (base) => ({
                                                                        ...base,
                                                                        zIndex: 9999
                                                                    }),
                                                                }}
                                                                menuPortalTarget={document.body}
                                                            />
                                                        </div>
                                                        <Button
                                                            variant="link"
                                                            size="sm"
                                                            onClick={() => setShowAddVendorModal(true)}
                                                            title="Add New Vendor"
                                                            className="p-0 text-primary flex-shrink-0"
                                                            style={{ color: 'var(--primary-color)' }}
                                                        >
                                                            <i className="fs-5 fa-solid fa-plus-square"></i>
                                                        </Button>
                                                    </div>
                                                </td>
                                                <td className="border-end p-2" style={{ width: '22%' }}>
                                                    <div className="d-flex gap-1 align-items-center">
                                                        <div className="flex-grow-1" style={{ minWidth: '0' }}>
                                                            <Select
                                                                value={getSelectedBook(index)}
                                                                onChange={(selectedOption) => handleMultiRowChange(index, "book_id", selectedOption ? selectedOption.value : "")}
                                                                options={bookOptions}
                                                                placeholder="Select Book"
                                                                isClearable
                                                                isSearchable
                                                                menuPlacement="auto"
                                                                styles={{
                                                                    control: (base, state) => ({
                                                                        ...base,
                                                                        width: "100%",
                                                                        minHeight: "36px",
                                                                        fontSize: "14px",
                                                                        borderColor: state.isFocused ? "var(--primary-color)" : row.book_id ? "#28a745" : "#dee2e6",
                                                                        backgroundColor: row.book_id ? "#f8fff9" : "white",
                                                                    }),
                                                                    menu: (base) => ({
                                                                        ...base,
                                                                        zIndex: 9999,
                                                                    }),
                                                                    menuPortal: (base) => ({
                                                                        ...base,
                                                                        zIndex: 9999
                                                                    }),
                                                                }}
                                                                menuPortalTarget={document.body}
                                                            />
                                                        </div>
                                                        <Button
                                                            variant="link"
                                                            size="sm"
                                                            onClick={() => setShowAddBookModal(true)}
                                                            title="Add New Book"
                                                            className="p-0 text-success flex-shrink-0"
                                                        >
                                                            <i className="fs-5 fa-solid fa-plus-square"></i>
                                                        </Button>
                                                    </div>
                                                </td>
                                                <td className="border-end p-2" style={{ width: '8%' }}>
                                                    <Form.Control
                                                        type="number"
                                                        value={row.quantity}
                                                        min="1"
                                                        step="1"
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            const intValue = Math.floor(Number(value));
                                                            handleMultiRowChange(index, "quantity", intValue < 1 ? 1 : intValue);
                                                        }}
                                                        className="border-0 p-1"
                                                    />
                                                </td>
                                                <td className="border-end p-2" style={{ width: '10%' }}>
                                                    <Form.Control
                                                        type="number"
                                                        value={row.unit_price}
                                                        min="0"
                                                        step="1"
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            const intValue = Math.floor(Number(value));
                                                            handleMultiRowChange(index, "unit_price", intValue < 0 ? 0 : intValue);
                                                        }}
                                                        className="border-0 p-1"
                                                    />
                                                </td>
                                                <td className="border-end p-2" style={{ width: '12%' }}>
                                                    <div className="bg-light p-2 rounded text-center">
                                                        <span className="fw-semibold" style={{ color: 'var(--primary-color)' }}>
                                                            {company?.currency || '₹'} {((parseFloat(row.quantity) || 0) * (parseFloat(row.unit_price) || 0)).toFixed(2)}
                                                        </span>
                                                    </div>
                                                </td>
                                                <td className="border-end p-2" style={{ width: '12%' }}>
                                                    <Form.Control
                                                        type="date"
                                                        value={row.purchase_date}
                                                        max={todayStr}
                                                        onChange={(e) => handleMultiRowChange(index, "purchase_date", e.target.value)}
                                                        className="border-0 p-1"
                                                        style={{ width: '100%' }}
                                                    />
                                                </td>
                                                <td className="border-end p-2" style={{ width: '12%' }}>
                                                    <Form.Control
                                                        type="text"
                                                        value={row.bill_number}
                                                        onChange={(e) => handleMultiRowChange(index, "bill_number", e.target.value)}
                                                        placeholder="Bill No..."
                                                        className="border-0 p-1"
                                                        style={{ width: '100%' }}
                                                    />
                                                </td>
                                                <td className="border-end p-2" style={{ width: '12%' }}>
                                                    <Form.Control
                                                        type="text"
                                                        value={row.notes}
                                                        onChange={(e) => handleMultiRowChange(index, "notes", e.target.value)}
                                                        placeholder="Add notes..."
                                                        className="border-0 p-1"
                                                        style={{ width: '100%' }}
                                                    />
                                                </td>
                                                <td className="text-center p-1" style={{ width: '2%' }}>
                                                    <Button
                                                        variant="link"
                                                        size="sm"
                                                        onClick={() => handleRemoveRow(index)}
                                                        disabled={multiInsertRows.length === 1}
                                                        title="Remove Row"
                                                        className="p-1 text-danger"
                                                        style={{ minWidth: 'auto' }}
                                                    >
                                                        <i className="fa-solid fa-trash fa-sm"></i>
                                                    </Button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </div>
                        </div>

                        <Row className="mt-4">
                            <Col lg={8}>
                                {/* Vendor Slips Section - Only show if user has payment permission */}
                                {hasPaymentPermission && uniqueVendors.length > 0 && (
                                    <Card className="shadow-sm border-0 mb-4" style={{
                                        background: 'white',
                                        borderRadius: '12px'
                                    }}>
                                        <Card.Body className="p-4">
                                            <h6 className="fw-bold mb-3 d-flex align-items-center">
                                                <i className="fa-solid fa-file-invoice me-2" style={{ color: 'var(--primary-color)' }}></i>
                                                Vendor-wise Slips ({uniqueVendors.length})
                                                {hasPaymentPermission && (
                                                    <Badge bg="info" className="ms-2" style={{ fontSize: '11px' }}>
                                                        <i className="fa-solid fa-credit-card me-1"></i>Invoice Enabled
                                                    </Badge>
                                                )}
                                            </h6>
                                            <div className="d-flex flex-wrap gap-2">
                                                {getUniqueVendors().map(vendor => (
                                                    <div key={vendor.id} className="border rounded p-3" style={{ minWidth: '250px', flex: '1 1 auto' }}>
                                                        <div className="d-flex justify-content-between align-items-start mb-2">
                                                            <div>
                                                                <strong>{vendor.name}</strong>
                                                                <div className="small text-muted">
                                                                    {vendor.rows.length} item(s) | Qty: {vendor.quantity}
                                                                </div>
                                                                <div className="fw-bold mt-1" style={{ color: 'var(--primary-color)' }}>
                                                                    {company?.currency || '₹'} {vendor.total.toFixed(2)}
                                                                </div>
                                                            </div>
                                                            <Dropdown>
                                                                <Dropdown.Toggle variant="outline-primary" size="sm" id={`dropdown-${vendor.id}`} style={{ borderColor: 'var(--primary-color)', color: 'var(--primary-color)' }}>
                                                                    <i className="fa-solid fa-print me-1"></i> Slip
                                                                </Dropdown.Toggle>
                                                                <Dropdown.Menu>
                                                                    <Dropdown.Item onClick={() => handleVendorSlipAction(vendor.id, 'view')}>
                                                                        <i className="fa-solid fa-eye me-2" style={{ color: 'var(--primary-color)' }}></i> View Slip
                                                                    </Dropdown.Item>
                                                                    <Dropdown.Item onClick={() => handleVendorSlipAction(vendor.id, 'print')}>
                                                                        <i className="fa-solid fa-print me-2" style={{ color: 'var(--primary-color)' }}></i> Print Slip
                                                                    </Dropdown.Item>
                                                                    <Dropdown.Item onClick={() => handleVendorSlipAction(vendor.id, 'download')}>
                                                                        <i className="fa-solid fa-download me-2" style={{ color: 'var(--primary-color)' }}></i> Download as HTML
                                                                    </Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </Card.Body>
                                    </Card>
                                )}
                            </Col>
                            <Col lg={4}>
                                <Card className="shadow-sm border-0" style={{
                                    background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                                    borderRadius: '12px'
                                }}>
                                    <Card.Body className="p-4">
                                        <h6 className="fw-bold mb-3 d-flex align-items-center">
                                            <i className="fa-solid fa-clipboard-check me-2" style={{ color: 'var(--primary-color)' }}></i>
                                            Purchase Summary
                                        </h6>

                                        <div className="mb-3">
                                            <div className="d-flex justify-content-between align-items-center mb-2 p-2 bg-white rounded">
                                                <span className="text-muted">Total Entries</span>
                                                <Badge bg="primary" pill>{multiInsertRows.length}</Badge>
                                            </div>

                                            <div className="d-flex justify-content-between align-items-center mb-2 p-2 bg-white rounded">
                                                <span className="text-muted">Vendors</span>
                                                <div className="d-flex align-items-center">
                                                    <Badge bg={uniqueVendors.length > 1 ? "warning" : "success"} pill>
                                                        {uniqueVendors.length}
                                                    </Badge>
                                                </div>
                                            </div>

                                            <div className="d-flex justify-content-between align-items-center p-2 bg-white rounded">
                                                <span className="text-muted">Total Books</span>
                                                <Badge bg="info" pill>{totalBooks}</Badge>
                                            </div>
                                        </div>

                                        <div className="p-3 rounded mb-3 text-center" style={{
                                            background: 'linear-gradient(135deg, var(--primary-color) 0%, #8b5cf6 100%)',
                                            color: 'white'
                                        }}>
                                            <small className="text-white-50 text-uppercase">Total Value</small>
                                            <div className="h4 mb-0 fw-bold">{company?.currency || '₹'} {totalAmount.toFixed(2)}</div>
                                        </div>

                                        <div className="mt-3">
                                            <Button
                                                variant="primary"
                                                className="w-100 mb-2 py-2 fw-bold"
                                                onClick={handleSavePurchases}
                                                disabled={saving || multiInsertRows.length === 0}
                                                style={{
                                                    background: 'linear-gradient(135deg, var(--primary-color) 0%, #8b5cf6 100%)',
                                                    border: 'none'
                                                }}
                                            >
                                                {saving ? (
                                                    <>
                                                        <i className="fa-solid fa-spinner fa-spin me-2"></i>
                                                        Saving...
                                                    </>
                                                ) : (
                                                    <>
                                                        <i className="fa-solid fa-save me-2"></i>
                                                        Save Purchases
                                                    </>
                                                )}
                                            </Button>

                                            {/* Only show invoice button if user has payment permission */}
                                            {hasPaymentPermission && (
                                                <Button
                                                    variant="outline-primary"
                                                    className="w-100 mb-2 py-2 fw-bold"
                                                    onClick={() => setShowInvoiceModal(true)}
                                                    disabled={multiInsertRows.length === 0 || multiInsertRows.every(r => !r.book_id || !r.vendor_id)}
                                                    style={{ borderColor: 'var(--primary-color)', color: 'var(--primary-color)' }}
                                                >
                                                    <i className="fa-solid fa-file-invoice me-2"></i>
                                                    View Combined Invoice
                                                </Button>
                                            )}

                                            <Button
                                                variant="outline-secondary"
                                                className="w-100 py-2"
                                                onClick={() => navigate('/purchase')}
                                            >
                                                <i className="fa-solid fa-arrow-left me-2"></i>
                                                Back to List
                                            </Button>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </>
                );

            case "import":
                return (
                    <PurchaseDataImport
                        selectedFile={selectedFile}
                        onFileChange={handleFileChange}
                        loading={loading}
                        vendors={vendors}
                        books={books}
                    />
                );

            default:
                return null;
        }
    };

    return (
        <>
            <ToastContainer position="top-right" autoClose={2000} />
            <Row className="align-items-center">
                <Col lg={6}></Col>
                <Col lg={6}>
                    <div className="d-flex gap-3 mb-3 justify-content-end">
                        <Card className="shadow-sm border-0" style={{
                            background: 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)',
                            borderRadius: "10px",
                            border: 'none',
                            width: '220px'
                        }}>
                            <Card.Body className="p-3">
                                <div className="d-flex align-items-center">
                                    <div className="p-2 rounded-circle me-2" style={{
                                        background: 'rgba(13, 110, 253, 0.15)'
                                    }}>
                                        <i className="fa-solid fa-book-open text-primary fa-sm"></i>
                                    </div>
                                    <div>
                                        <p className="mb-0 small text-muted">Issued</p>
                                        <h5 className="mb-0 fw-bold text-primary">{stats.issued}</h5>
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>

                        <Card className="shadow-sm border-0" style={{
                            background: 'linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)',
                            borderRadius: "10px",
                            border: 'none',
                            width: '220px'
                        }}>
                            <Card.Body className="p-3">
                                <div className="d-flex align-items-center">
                                    <div className="p-2 rounded-circle me-2" style={{
                                        background: 'rgba(40, 167, 69, 0.15)'
                                    }}>
                                        <i className="fa-solid fa-cart-shopping text-success fa-sm"></i>
                                    </div>
                                    <div>
                                        <p className="mb-0 small text-muted">Purchased</p>
                                        <h5 className="mb-0 fw-bold text-success">{stats.purchased}</h5>
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>

                        <Card className="shadow-sm border-0" style={{
                            background: 'linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%)',
                            borderRadius: "10px",
                            border: 'none',
                            width: '220px'
                        }}>
                            <Card.Body className="p-3">
                                <div className="d-flex align-items-center">
                                    <div className="p-2 rounded-circle me-2" style={{
                                        background: 'rgba(255, 193, 7, 0.15)'
                                    }}>
                                        <i className="fa-solid fa-layer-group text-warning fa-sm"></i>
                                    </div>
                                    <div>
                                        <p className="mb-0 small text-muted">Available</p>
                                        <h5 className="mb-0 fw-bold text-warning">{stats.available}</h5>
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>
                    </div>
                </Col>
            </Row>

            <Container fluid className="py-3" style={{
                minHeight: '100vh',
                backgroundColor: '#f5f7fb'
            }}>
                <div className="mb-1">
                    <h4 className="fw-bold text-dark mb-1">
                        <i className="fa-solid fa-cart-plus" style={{ color: 'var(--primary-color)' }}></i>
                        Bulk Purchase Entry
                    </h4>
                    <Tabs
                        activeKey={activeTab}
                        onSelect={(k) => setActiveTab(k)}
                        className="custom-tabs"
                        id="purchase-tabs"
                    >
                        <Tab
                            eventKey="single"
                            title={
                                <div className="d-flex align-items-center px-3 py-2">
                                    Single Vendor
                                </div>
                            }
                            className="pt-3"
                        />
                        {/* <Tab
                            eventKey="import"
                            title={
                                <div className="d-flex align-items-center px-3 py-2">
                                    Import Data
                                </div>
                            }
                            className="pt-3"
                        /> */}
                    </Tabs>
                </div>

                <Row>
                    <Col lg={12}>
                        <Card className="shadow-sm border-0" style={{
                            background: 'white',
                            borderRadius: '12px'
                        }}>
                            <Card.Body className="p-4">
                                {renderTabContent()}
                            </Card.Body>
                            {/* renderTabContent MOVED ↑ to fix parsing error (lines ~1088-1400) */}
                        </Card>
                    </Col>
                </Row>

                {/* Add Vendor Modal */}
                <Modal backdrop="static" show={showAddVendorModal} onHide={() => setShowAddVendorModal(false)} size="lg" centered>
                    <Modal.Header closeButton className="border-bottom-0 pb-2"
                        style={{ backgroundColor: "var(--secondary-color)", color: "var(--primary-color)" }}>
                        <Modal.Title className="fw-bold" style={{ color: 'var(--primary-color)' }}>
                            Add New Vendor
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="pt-0">
                        <Form>
                            {/* Contact Information */}
                            <div className="mt-2 mb-4">
                                <div
                                    className="d-flex align-items-center mt-2 p-2"
                                    style={{ backgroundColor: "var(--secondary-color)", color: "var(--primary-color)", borderRadius: "8px" }}>
                                    <h6 className="mb-0 fw-bold" style={{ color: "var(--primary-color)" }}>
                                        Contact Person Information
                                    </h6>
                                </div>

                                <Row>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>
                                                Contact Person Name<span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={vendorFormData.name}
                                                onChange={(e) =>
                                                    setVendorFormData({
                                                        ...vendorFormData,
                                                        name: e.target.value,
                                                    })
                                                }
                                                placeholder="Enter contact person name"

                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Company Name</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={vendorFormData.company_name}
                                                onChange={(e) =>
                                                    setVendorFormData({
                                                        ...vendorFormData,
                                                        company_name: e.target.value,
                                                    })
                                                }
                                                placeholder="Enter company name"
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={3}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Country Code</Form.Label>
                                            <Form.Select
                                                value={vendorFormData.country_code}
                                                onChange={(e) =>
                                                    setVendorFormData({
                                                        ...vendorFormData,
                                                        country_code: e.target.value,
                                                    })
                                                }
                                            >
                                                {COUNTRY_CODES.map((country, index) => (
                                                    <option key={index} value={country.country_code}>
                                                        {country.country_code} - {country.country}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>

                                    <Col md={3}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Phone</Form.Label>
                                            <Form.Control
                                                type="tel"
                                                value={vendorFormData.phone}
                                                onChange={(e) =>
                                                    setVendorFormData({
                                                        ...vendorFormData,
                                                        phone: e.target.value,
                                                    })
                                                }
                                                placeholder="Enter phone number"
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Email</Form.Label>
                                            <Form.Control
                                                type="email"
                                                value={vendorFormData.email}
                                                onChange={(e) =>
                                                    setVendorFormData({
                                                        ...vendorFormData,
                                                        email: e.target.value,
                                                    })
                                                }
                                                placeholder="Enter email address"
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </div>

                            {/* Company Information */}
                            <div className="mb-3">
                                <div
                                    className="d-flex align-items-center mb-3 p-2"
                                    style={{ backgroundColor: "var(--secondary-color)", color: "var(--primary-color)", borderRadius: "8px" }}>
                                    <h6 className="mb-0 fw-bold" style={{ color: "var(--primary-color)" }}>
                                        Company Information
                                    </h6>
                                </div>

                                <Row>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>GST Number</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={vendorFormData.gst_number}
                                                onChange={(e) =>
                                                    setVendorFormData({
                                                        ...vendorFormData,
                                                        gst_number: e.target.value,
                                                    })
                                                }
                                                placeholder="Enter GST number"
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>PAN Number</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={vendorFormData.pan_number}
                                                onChange={(e) =>
                                                    setVendorFormData({
                                                        ...vendorFormData,
                                                        pan_number: e.target.value,
                                                    })
                                                }
                                                placeholder="Enter PAN number"
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Country</Form.Label>
                                            <Form.Select
                                                value={vendorFormData.country}
                                                onChange={(e) =>
                                                    setVendorFormData({
                                                        ...vendorFormData,
                                                        country: e.target.value,
                                                        state: "",
                                                        city: "",
                                                    })
                                                }
                                            >
                                                {Country.getAllCountries().map((country) => (
                                                    <option key={country.isoCode} value={country.name}>
                                                        {country.name}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>State</Form.Label>
                                            <Form.Select
                                                value={vendorFormData.state}
                                                onChange={(e) =>
                                                    setVendorFormData({
                                                        ...vendorFormData,
                                                        state: e.target.value,
                                                        city: "",
                                                    })
                                                }
                                            >
                                                {State.getStatesOfCountry(
                                                    Country.getAllCountries().find(
                                                        (c) => c.name === vendorFormData.country
                                                    )?.isoCode
                                                ).map((state) => (
                                                    <option key={state.isoCode} value={state.name}>
                                                        {state.name}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>City</Form.Label>
                                            <Form.Select
                                                value={vendorFormData.city}
                                                onChange={(e) =>
                                                    setVendorFormData({
                                                        ...vendorFormData,
                                                        city: e.target.value,
                                                    })
                                                }
                                            >
                                                {City.getCitiesOfState(
                                                    Country.getAllCountries().find(
                                                        (c) => c.name === vendorFormData.country
                                                    )?.isoCode,
                                                    State.getStatesOfCountry(
                                                        Country.getAllCountries().find(
                                                            (c) => c.name === vendorFormData.country
                                                        )?.isoCode
                                                    ).find((s) => s.name === vendorFormData.state)?.isoCode
                                                ).map((city) => (
                                                    <option key={city.name} value={city.name}>
                                                        {city.name}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Pincode</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={vendorFormData.pincode}
                                                onChange={(e) =>
                                                    setVendorFormData({
                                                        ...vendorFormData,
                                                        pincode: e.target.value,
                                                    })
                                                }
                                                placeholder="Enter pincode"
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Address</Form.Label>
                                            <Form.Control
                                                as="textarea"
                                                rows={2}
                                                value={vendorFormData.address}
                                                onChange={(e) =>
                                                    setVendorFormData({
                                                        ...vendorFormData,
                                                        address: e.target.value,
                                                    })
                                                }
                                                placeholder="Enter full address"
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={6}>
                                        <Form.Group className='mb-3'>
                                            <Form.Label>Status</Form.Label>
                                            <Form.Check
                                                type="switch"
                                                checked={vendorFormData.status}
                                                onChange={(e) =>
                                                    setVendorFormData({
                                                        ...vendorFormData,
                                                        status: e.target.checked,
                                                    })
                                                }
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </div>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer className="border-top-0">
                        <Button variant="outline-secondary" onClick={() => setShowAddVendorModal(false)}>
                            Cancel
                        </Button>
                        <Button variant="primary" onClick={handleAddVendor} disabled={loading} style={{ backgroundColor: 'var(--primary-color)', borderColor: 'var(--primary-color)' }}>
                            {loading ? (
                                <>
                                    <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                    Adding...
                                </>
                            ) : (
                                "Save"
                            )}
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Add Book Modal */}
                <Modal show={showAddBookModal} onHide={() => {
                    setShowAddBookModal(false);
                    setBarcodeInput("");
                }} size="lg" centered>
                    <Modal.Header closeButton className="p-2" style={{ backgroundColor: "var(--secondary-color)", color: "var(--primary-color)" }}>
                        <Modal.Title className="fw-bold" style={{ color: 'var(--primary-color)' }}>
                            <i className="fa-solid fa-book me-2" style={{ color: "var(--primary-color)" }}></i>
                            Add New Book
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="pt-0">
                        <Card className="mb-4 border-0">
                            <Card.Body className="p-3">
                                <UniversalBarcodeScanner onBarcodeScanned={handleBarcodeScanned} />
                                <Form.Group>
                                    <Form.Label className="small fw-semibold">Enter ISBN/Barcode</Form.Label>
                                    <InputGroup>
                                        <Form.Control
                                            type="text"
                                            value={barcodeInput}
                                            placeholder="Enter ISBN or barcode number"
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                setBarcodeInput(value);
                                                if (autoLookupTimeout) clearTimeout(autoLookupTimeout);
                                                if (value.length >= 10) {
                                                    const timeout = setTimeout(() => handleBarcodeLookup(value), 1500);
                                                    setAutoLookupTimeout(timeout);
                                                }
                                            }}
                                            onKeyPress={(e) => {
                                                if (e.key === "Enter") handleBarcodeLookup(barcodeInput);
                                            }}
                                        />
                                        <Button variant="primary" onClick={() => handleBarcodeLookup(barcodeInput)}
                                            disabled={!barcodeInput.trim() || loading || barcodeProcessing}
                                            style={{ backgroundColor: 'var(--primary-color)', borderColor: 'var(--primary-color)' }}>
                                            {loading || barcodeProcessing
                                                ? <i className="fa-solid fa-spinner fa-spin"></i>
                                                : <i className="fa-solid fa-search"></i>}
                                        </Button>
                                    </InputGroup>
                                </Form.Group>
                            </Card.Body>
                        </Card>

                        <Form>
                            <Row>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Title <span className="text-danger">*</span></Form.Label>
                                        <Form.Control type="text" value={bookFormData.title || ""}
                                            onChange={(e) => setBookFormData({ ...bookFormData, title: e.target.value })}
                                            placeholder="Enter book title" />
                                    </Form.Group>
                                </Col>

                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Author <span className="text-danger">*</span></Form.Label>
                                        <Select
                                            value={authorOptions.find(o => o.value === bookFormData.author_id) || null}
                                            onChange={(opt) => setBookFormData({ ...bookFormData, author_id: opt ? opt.value : "" })}
                                            options={authorOptions}
                                            placeholder="Select Author"
                                            isClearable isSearchable
                                            menuPortalTarget={document.body}
                                            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                                        />
                                    </Form.Group>
                                </Col>

                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Classification <span className="text-danger">*</span></Form.Label>
                                        <AsyncSelect
                                            value={bookFormData.classification_label
                                                ? { value: bookFormData.classification_id, label: bookFormData.classification_label }
                                                : null}
                                            loadOptions={async (inputValue) => {
                                                try {
                                                    const api = (await import('../../api/dataApi')).default;
                                                    const classificationApi = new api('classification');
                                                    const response = await classificationApi.get('/');
                                                    const classifications = response.data || [];
                                                    const filtered = inputValue
                                                        ? classifications.filter(item => {
                                                            const s = inputValue.toLowerCase().trim();
                                                            if (item.category?.toLowerCase().includes(s) ||
                                                                item.name?.toLowerCase().includes(s) ||
                                                                item.code?.toLowerCase().includes(s)) return true;
                                                            if (item.classification_from && item.classification_to) {
                                                                if (/^\d+$/.test(s) && /^\d+$/.test(item.classification_from)) {
                                                                    const n = parseInt(s);
                                                                    if (n >= parseInt(item.classification_from) &&
                                                                        n <= parseInt(item.classification_to)) return true;
                                                                }
                                                            }
                                                            return false;
                                                        })
                                                        : classifications;
                                                    return filtered.map(item => ({
                                                        value: item.id,
                                                        label: `${item.category || ''} - ${item.name} (${item.code})`,
                                                        data: item
                                                    }));
                                                } catch (e) { return []; }
                                            }}
                                            onChange={(opt) => {
                                                if (opt && opt.data) {
                                                    const selected = opt.data;
                                                    setBookFormData(prev => ({
                                                        ...prev,
                                                        classification_id: opt.value,
                                                        classification_label: opt.label,
                                                        classification_category: selected.category || '',
                                                        classification_type: selected.classification_type || '',
                                                        classification_code: selected.code || '',
                                                        classification_from: selected.classification_from || '',
                                                        classification_to: selected.classification_to || '',
                                                    }));
                                                } else {
                                                    setBookFormData(prev => ({
                                                        ...prev,
                                                        classification_id: "", classification_label: "",
                                                        classification_category: "", classification_type: "",
                                                        classification_code: "", classification_from: "", classification_to: ""
                                                    }));
                                                }
                                            }}
                                            defaultOptions isClearable
                                            placeholder="Search classification by name, code or range"
                                            menuPortalTarget={document.body}
                                            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                                        />
                                        <Form.Text className="text-muted">Supports DDC (000-099) and LLC (AC-AZ) classifications.</Form.Text>
                                    </Form.Group>
                                </Col>

                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Classification Type</Form.Label>
                                        <Form.Control type="text" value={bookFormData.classification_type || ""} readOnly placeholder="Auto-filled" />
                                    </Form.Group>
                                </Col>

                                <Col md={3}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Range From</Form.Label>
                                        <Form.Control type="text" value={bookFormData.classification_from || ""} readOnly placeholder="Auto-filled" />
                                    </Form.Group>
                                </Col>

                                <Col md={3}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Range To</Form.Label>
                                        <Form.Control type="text" value={bookFormData.classification_to || ""} readOnly placeholder="Auto-filled" />
                                    </Form.Group>
                                </Col>

                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Publisher</Form.Label>
                                        <Select
                                            value={publisherOptions.find(o => o.value === bookFormData.publisher_id) || null}
                                            onChange={(opt) => setBookFormData({ ...bookFormData, publisher_id: opt ? opt.value : "" })}
                                            options={publisherOptions}
                                            placeholder="Select Publisher"
                                            isClearable isSearchable
                                            menuPortalTarget={document.body}
                                            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                                        />
                                    </Form.Group>
                                </Col>

                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>ISBN/ISSN <span className="text-danger">*</span></Form.Label>
                                        <Form.Control type="text" value={bookFormData.isbn || ""}
                                            onChange={(e) => setBookFormData({ ...bookFormData, isbn: e.target.value })}
                                            placeholder="Enter ISBN/ISSN" />
                                    </Form.Group>
                                </Col>

                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Min Age <span className="text-danger">*</span></Form.Label>
                                        <Form.Control type="number" min={0} value={bookFormData.min_age || ""}
                                            onChange={(e) => setBookFormData({ ...bookFormData, min_age: e.target.value })}
                                            placeholder="Enter minimum age" />
                                    </Form.Group>
                                </Col>

                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Inventory Binding</Form.Label>
                                        <Select
                                            value={[
                                                { value: "hardcover", label: "Hardcover" },
                                                { value: "paperback", label: "Paperback" },
                                                { value: "spiral", label: "Spiral" },
                                            ].find(o => o.value === bookFormData.inventory_binding) || null}
                                            onChange={(opt) => setBookFormData({ ...bookFormData, inventory_binding: opt ? opt.value : "" })}
                                            options={[
                                                { value: "hardcover", label: "Hardcover" },
                                                { value: "paperback", label: "Paperback" },
                                                { value: "spiral", label: "Spiral" },
                                            ]}
                                            placeholder="Select Binding" isClearable
                                            menuPortalTarget={document.body}
                                            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                                        />
                                    </Form.Group>
                                </Col>

                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Language</Form.Label>
                                        <Form.Control type="text" value={bookFormData.language || ""}
                                            onChange={(e) => setBookFormData({ ...bookFormData, language: e.target.value })}
                                            placeholder="Enter language" />
                                    </Form.Group>
                                </Col>

                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Edition</Form.Label>
                                        <Form.Control type="text" value={bookFormData.edition || ""}
                                            onChange={(e) => setBookFormData({ ...bookFormData, edition: e.target.value })}
                                            placeholder="e.g. 1st Edition" />
                                    </Form.Group>
                                </Col>

                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Publication Year</Form.Label>
                                        <Form.Control type="number" value={bookFormData.publication_year || ""}
                                            onChange={(e) => setBookFormData({ ...bookFormData, publication_year: e.target.value })}
                                            placeholder="e.g. 2023" />
                                    </Form.Group>
                                </Col>

                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Total Pages</Form.Label>
                                        <Form.Control type="number" value={bookFormData.pages || ""}
                                            onChange={(e) => setBookFormData({ ...bookFormData, pages: e.target.value })}
                                            placeholder="Enter page count" />
                                    </Form.Group>
                                </Col>

                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Status</Form.Label>
                                        <div>
                                            <Form.Check type="switch" id="status-switch"
                                                label={bookFormData.status === "ACTIVE" ? "Active" : "Inactive"}
                                                checked={bookFormData.status === "ACTIVE"}
                                                onChange={(e) => setBookFormData({
                                                    ...bookFormData,
                                                    status: e.target.checked ? "ACTIVE" : "INACTIVE"
                                                })} />
                                        </div>
                                        <Form.Text className="text-muted">Switch to deactivate this book globally</Form.Text>
                                    </Form.Group>
                                </Col>

                                {company?.book_bank === true && (
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Check type="checkbox" id="book-bank-checkbox" label="Book Bank"
                                                checked={bookFormData.is_book_bank || false}
                                                onChange={(e) => setBookFormData({ ...bookFormData, is_book_bank: e.target.checked })} />
                                            <Form.Text className="text-muted">Check if this book is part of the book bank collection</Form.Text>
                                        </Form.Group>
                                    </Col>
                                )}
                            </Row>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer className="border-top-0">
                        <Button variant="outline-secondary" onClick={() => { setShowAddBookModal(false); setBarcodeInput(""); }}>
                            Cancel
                        </Button>
                        <Button variant="success" onClick={handleAddBook} disabled={loading}>
                            {loading ? (
                                <><span className="spinner-border spinner-border-sm me-2" role="status"></span>Adding...</>
                            ) : (
                                <><i className="fa-solid fa-plus me-2"></i>Save</>
                            )}
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Vendor Slip Modal - Only show if user has payment permission */}
                {hasPaymentPermission && (
                    <Modal show={showVendorSlipModal} onHide={() => setShowVendorSlipModal(false)} size="xl" centered>
                        <Modal.Header closeButton style={{ backgroundColor: "var(--secondary-color)", color: "var(--primary-color)" }}>
                            <Modal.Title className="fw-bold" style={{ color: 'var(--primary-color)' }}>
                                <i className="fa-solid fa-file-invoice me-2"></i>
                                Vendor Slip - {selectedVendorForSlip && (vendorOptions.find(v => v.value === selectedVendorForSlip)?.label || "Vendor")}
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {selectedVendorForSlip && (
                                <div
                                    id={`vendor-slip-${selectedVendorForSlip}`}
                                    dangerouslySetInnerHTML={{ __html: generateVendorSlipHTML(selectedVendorForSlip) }}
                                />
                            )}
                        </Modal.Body>
                        <Modal.Footer className="border-top-0 d-flex justify-content-between">
                            <div>
                                <Button variant="outline-secondary" onClick={() => setShowVendorSlipModal(false)}>
                                    <i className="fa-solid fa-times me-2"></i>Close
                                </Button>
                            </div>
                            <div className="d-flex gap-2">
                                <Button variant="outline-primary" onClick={() => selectedVendorForSlip && printVendorSlip(selectedVendorForSlip)} style={{ borderColor: 'var(--primary-color)', color: 'var(--primary-color)' }}>
                                    <i className="fa-solid fa-print me-2"></i>Print Slip
                                </Button>
                                <Button variant="outline-success" onClick={() => selectedVendorForSlip && downloadVendorSlip(selectedVendorForSlip)}>
                                    <i className="fa-solid fa-download me-2"></i>Download HTML
                                </Button>
                            </div>
                        </Modal.Footer>
                    </Modal>
                )}

                {/* Invoice Modal - Only shown if user has payment permission */}
                {hasPaymentPermission && (
                    <Modal show={showInvoiceModal} onHide={() => setShowInvoiceModal(false)} size="xl" centered>
                        <Modal.Header closeButton style={{ backgroundColor: "var(--secondary-color)", color: "var(--primary-color)" }}>
                            <Modal.Title className="fw-bold" style={{ color: 'var(--primary-color)' }}>
                                <i className="fa-solid fa-file-invoice me-2"></i>Combined Purchase Invoice
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div id="invoice-print-area" style={{ padding: "30px", fontFamily: "Arial, sans-serif" }}>
                                {/* Header */}
                                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "30px", borderBottom: "3px solid var(--primary-color)", paddingBottom: "20px" }}>
                                    <div>
                                        <h2 style={{ color: "var(--primary-color)", margin: 0 }}>{company?.name || "Library"}</h2>
                                        <p style={{ margin: "5px 0", color: "#666" }}>{company?.address || ""}</p>
                                        <p style={{ margin: "5px 0", color: "#666" }}>{company?.email || ""} {company?.phone ? `| ${company.phone}` : ""}</p>
                                    </div>
                                    <div style={{ textAlign: "right" }}>
                                        <h3 style={{ color: "var(--primary-color)", margin: 0 }}>PURCHASE INVOICE</h3>
                                        <p style={{ margin: "5px 0" }}><strong>Date:</strong> {new Date().toLocaleDateString('en-IN')}</p>
                                        <p style={{ margin: "5px 0" }}><strong>Invoice #:</strong> INV-{Date.now().toString().slice(-8)}</p>
                                    </div>
                                </div>

                                {/* Vendor Info - group by vendor */}
                                {[...new Set(multiInsertRows.map(r => r.vendor_id).filter(Boolean))].map(vendorId => {
                                    const vendorRows = multiInsertRows.filter(r => r.vendor_id === vendorId);
                                    const vendorName = vendorOptions.find(v => v.value === vendorId)?.label || "Unknown Vendor";
                                    const vendorTotal = vendorRows.reduce((sum, r) => sum + ((parseFloat(r.quantity) || 0) * (parseFloat(r.unit_price) || 0)), 0);

                                    return (
                                        <div key={vendorId} style={{ marginBottom: "30px", border: "1px solid #dee2e6", borderRadius: "8px", overflow: "hidden" }}>
                                            <div style={{ backgroundColor: "var(--secondary-color)", padding: "12px 20px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                                <div>
                                                    <strong style={{ color: "var(--primary-color)", fontSize: "16px" }}>
                                                        <i className="fa-solid fa-store me-2"></i>{vendorName}
                                                    </strong>
                                                </div>
                                                <div style={{ color: "var(--primary-color)", fontWeight: "bold" }}>
                                                    Subtotal: {company?.currency || "₹"} {vendorTotal.toFixed(2)}
                                                </div>
                                            </div>

                                            <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                                <thead>
                                                    <tr style={{ backgroundColor: "#f8f9fa" }}>
                                                        <th style={{ padding: "10px 15px", borderBottom: "2px solid #dee2e6", textAlign: "left", width: "5%" }}>#</th>
                                                        <th style={{ padding: "10px 15px", borderBottom: "2px solid #dee2e6", textAlign: "left", width: "35%" }}>Book Title</th>
                                                        <th style={{ padding: "10px 15px", borderBottom: "2px solid #dee2e6", textAlign: "center", width: "15%" }}>Purchase Date</th>
                                                        <th style={{ padding: "10px 15px", borderBottom: "2px solid #dee2e6", textAlign: "center", width: "10%" }}>Qty</th>
                                                        <th style={{ padding: "10px 15px", borderBottom: "2px solid #dee2e6", textAlign: "right", width: "15%" }}>Unit Price</th>
                                                        <th style={{ padding: "10px 15px", borderBottom: "2px solid #dee2e6", textAlign: "right", width: "15%" }}>Amount</th>
                                                        <th style={{ padding: "10px 15px", borderBottom: "2px solid #dee2e6", textAlign: "left", width: "15%" }}>Notes</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {vendorRows.map((row, idx) => {
                                                        const bookLabel = bookOptions.find(b => b.value === row.book_id)?.label || "—";
                                                        const amount = (parseFloat(row.quantity) || 0) * (parseFloat(row.unit_price) || 0);
                                                        return (
                                                            <tr key={idx} style={{ borderBottom: "1px solid #f0f0f0", backgroundColor: idx % 2 === 0 ? "white" : "#fafafa" }}>
                                                                <td style={{ padding: "10px 15px" }}>{idx + 1}</td>
                                                                <td style={{ padding: "10px 15px" }}>{bookLabel}</td>
                                                                <td style={{ padding: "10px 15px", textAlign: "center" }}>{row.purchase_date}</td>
                                                                <td style={{ padding: "10px 15px", textAlign: "center" }}>{row.quantity}</td>
                                                                <td style={{ padding: "10px 15px", textAlign: "right" }}>{company?.currency || "₹"} {parseFloat(row.unit_price || 0).toFixed(2)}</td>
                                                                <td style={{ padding: "10px 15px", textAlign: "right", fontWeight: "600", color: "var(--primary-color)" }}>{company?.currency || "₹"} {amount.toFixed(2)}</td>
                                                                <td style={{ padding: "10px 15px", fontSize: "13px", color: "#666" }}>{row.notes || "—"}</td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    );
                                })}

                                {/* Grand Total */}
                                <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "10px" }}>
                                    <div style={{ minWidth: "300px", border: "2px solid var(--primary-color)", borderRadius: "8px", overflow: "hidden" }}>
                                        <div style={{ display: "flex", justifyContent: "space-between", padding: "10px 20px", backgroundColor: "#f8f9fa" }}>
                                            <span>Total Books (Qty)</span>
                                            <strong>{multiInsertRows.reduce((s, r) => s + (parseInt(r.quantity) || 0), 0)}</strong>
                                        </div>
                                        <div style={{ display: "flex", justifyContent: "space-between", padding: "10px 20px", backgroundColor: "#f8f9fa" }}>
                                            <span>Total Entries</span>
                                            <strong>{multiInsertRows.length}</strong>
                                        </div>
                                        <div style={{ display: "flex", justifyContent: "space-between", padding: "15px 20px", backgroundColor: "var(--primary-color)", color: "white" }}>
                                            <strong style={{ fontSize: "18px" }}>GRAND TOTAL</strong>
                                            <strong style={{ fontSize: "18px" }}>{company?.currency || "₹"} {totalAmount.toFixed(2)}</strong>
                                        </div>
                                    </div>
                                </div>

                                {/* Footer */}
                                <div style={{ marginTop: "40px", paddingTop: "20px", borderTop: "1px solid #dee2e6", display: "flex", justifyContent: "space-between", color: "#888", fontSize: "13px" }}>
                                    <span>Generated on {new Date().toLocaleString('en-IN')}</span>
                                    <span>This is a computer-generated invoice</span>
                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer className="border-top-0 d-flex justify-content-between">
                            <div>
                                <Button variant="outline-secondary" className="me-2" onClick={() => setShowInvoiceModal(false)}>
                                    <i className="fa-solid fa-times me-2"></i>Close
                                </Button>
                            </div>
                            <div className="d-flex gap-2">
                                <Button variant="outline-primary" onClick={() => {
                                    const printContent = document.getElementById('invoice-print-area').innerHTML;
                                    const printWindow = window.open('', '_blank');
                                    printWindow.document.write(`
                                        <html>
                                        <head>
                                            <title>Purchase Invoice</title>
                                            <style>
                                                body { font-family: Arial, sans-serif; margin: 20px; }
                                                table { width: 100%; border-collapse: collapse; }
                                                th, td { padding: 10px 15px; }
                                                thead tr { background: #f8f9fa; }
                                                @media print {
                                                    body { margin: 0; }
                                                    button { display: none; }
                                                }
                                            </style>
                                        </head>
                                        <body>${printContent}</body>
                                        </html>
                                    `);
                                    printWindow.document.close();
                                    printWindow.focus();
                                    printWindow.print();
                                }} style={{ borderColor: 'var(--primary-color)', color: 'var(--primary-color)' }}>
                                    <i className="fa-solid fa-print me-2"></i>Print
                                </Button>

                                <Button variant="success" onClick={async () => {
                                    setShowInvoiceModal(false);
                                    await handleSavePurchases();
                                }} disabled={saving}>
                                    {saving ? (
                                        <><i className="fa-solid fa-spinner fa-spin me-2"></i>Saving...</>
                                    ) : (
                                        <><i className="fa-solid fa-save me-2"></i>Save Purchases</>
                                    )}
                                </Button>
                            </div>
                        </Modal.Footer>
                    </Modal>
                )}

                <style>{`
                    .custom-tabs .nav-link {
                        border: none;
                        color: #6c757d;
                        font-weight: 500;
                        margin-right: 0.5rem;
                        border-radius: 8px 8px 0 0;
                        transition: all 0.3s ease;
                    }
                    .custom-tabs .nav-link:hover {
                        color: var(--primary-color);
                        background-color: rgba(111, 66, 193, 0.1);
                    }
                    .custom-tabs .nav-link.active {
                        color: var(--primary-color);
                        background-color: white;
                        border-bottom: 3px solid var(--primary-color);
                        font-weight: 600;
                    }
                    .custom-tabs .nav-tabs {
                        border-bottom: 1px solid #dee2e6;
                    }
                    .table-row-light {
                        background-color: #fafafa;
                    }
                    .table-row-light:hover {
                        background-color: #f0f0f0;
                    }
                    .react-select__menu {
                        z-index: 9999 !important;
                    }
                    .react-select__menu-portal {
                        z-index: 9999 !important;
                    }
                `}</style>
            </Container>
        </>
    );
};

export default BulkPurchasePage;